export function scrollAnimationContents() {
  const fadeTargetList = document.querySelectorAll(
    'section > div.wp-block-group__inner-container > *:not(.c-dialog__modal, .c-dialog__modal__data)'
  );

  fadeTargetList.forEach((fadeTargetOn) => {
    fadeTargetOn.classList.add('is-fadeItem');
    fadeTargetOn.style.opacity = '0';
  });
}

export function scrollAnimationContentsShow() {
  const targets = document.querySelectorAll('.is-fadeItem');
  const options = {
    root: null,
    rootMargin: '0px 20%',
    threshold: 0,
  };

  const observer = new IntersectionObserver(doWhenIntersect, options);

  targets.forEach(function (target) {
    observer.observe(target);
  });

  function doWhenIntersect(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-show');
        entry.target.style.opacity = '1';
      }
    });
  }
}
